import React from 'react';
import { Dropdown, Search, Grid, Input, Card, Popup, Header, Icon, Button } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import DeleteIcon from '@material-ui/icons/Delete';
import Mrp from '../../Sales/Quotation/relatedinfo';

class Item extends React.PureComponent {

  state = {
    brandOption: [],
    partcodeOption: [],
    dnp: 0,
    stock: 0,
    partId: 0,
    load: false,
    messgae: '',
    tax: 0,
    open: true
  }

  componentDidMount() {
    let context = this;
    $("#dnp"+context.props.id).keyup(function(event) {
      if (event.keyCode === 9) {
        context.props.addButton();
      }
    });
  }


  partcode = event => {
    let val = event.target.value;
    let brandname = val.split('->')[3];
    let partno = val.split('->')[0];
    this.getPartsAndBrand(partno, brandname);
  };

  getPartsAndBrand(partno, brandname) {
    let items = this.props.items;
    let data = this.props.partcodeOption;
    let valuess = 0;
    let id, brand_id, spare_name, brand_name, part_id, tax, mrp, ids, dnp,  part_alias;
    for (var i = 0; i < data.length; i++) {
      if (data[i].partno == partno && data[i].brand_name == brandname) {
        valuess = 1;
        id = this.props.id;
        brand_id = data[i].brand_id;
        spare_name = data[i].spare_name;
        brand_name = data[i].brand_name;
        part_id = data[i].part_id;
        tax = data[i].tax;
        mrp = data[i].mrp;
        ids = data[i].id;
        dnp = data[i].dnp;
        part_alias = data[i].part_alias;
      }
    }
    if (valuess != 0) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].id == id) {
          items[i].partno = partno;
          items[i].brand = brand_id;
          items[i].brandname = brand_name;
          items[i].partname = spare_name;
          items[i].part_id = part_id;
          items[i].partcode = part_id;
          items[i].tax = tax;
          items[i].mrp = mrp;
          items[i].aliasId = ids;
          items[i].invoice = this.props.invoice;
          items[i].invoice_date = this.props.invoiceDate;
          items[i].dnp = dnp;
          items[i].part_alias = part_alias;
          items[i].changeindnp = 0;
        }
      }
      this.props.saveItems(items);
    }
    this.props.updateItem(this.props.id, 'partno', partno);
  }

  onChanges = (type) => (f, { value }) => {
    this.props.updateItem(this.props.id, type, value);
  }

  updateItems(mrp, tax) {
    this.props.updateItem(this.props.id, 'mrp', mrp);
  }

  handleResultSelect = (e, { result }) => {
    this.partcode(result.title)
  }

  handleSearchChange = (e, { value }) => {
    let results = [];
    this.props.partcodeOption1.map((c) => {
      let string = c.text;
      var available = string.includes(value);
      if (available == true) {
        results.push({ title: c.text})
      }
    })
    this.setState({ results })
  }

  render() {
    let total = this.props.allItems.dnp * this.props.allItems.stock;
    let tax = total * (this.props.allItems.tax/100);
    let taxable = total + ((total * this.props.allItems.tax)/100);
    taxable = taxable.toFixed(2);
    tax = tax.toFixed(2);
    total = total.toFixed(2);
    return (
      <tbody>
        <Loading load={this.props.load} message={this.props.message} />
        <tr style={{backgroundColor: this.props.allItems.backgroundColor}}>
            <td><center>{this.props.count}</center></td>
            <td>
            <div>
              <datalist id="suggestionspartno">
                  {this.props.partcodeOption1.map((c) => {
                    return (
                      <option id='box'>{c.text}</option>
                    )
                  })}
              </datalist>
              <input style={{height: 35, width: '100%'}} onChange={this.partcode} autoComplete="on"
              list="suggestionspartno" value={this.props.allItems.partno} id={'spare'+this.props.id} />
            </div>
            </td>
            <td>{this.props.allItems.partname}</td>
            <td>{this.props.allItems.brandname}</td>
            <td><Input type="number" value={this.props.allItems.stock} fluid onChange={this.onChanges('stock')} focus /></td>
            <td>
              <Input id={'dnp'+this.props.id} type="number" value={this.props.allItems.dnp} fluid onChange={this.onChanges('dnp')} focus />
            </td>
            <td><center>{total}</center></td>
            <td>
              <center>
                { (this.props.branchState == this.props.purchaseState) ?
                  (
                    <Popup trigger={<Header as='h4'>{(tax)}</Header>} >
                      <Popup.Content>
                      <div>CGST: {this.props.allItems.tax/2} (Rs. {tax/2})</div><br/>
                      <div>SGST: {this.props.allItems.tax/2} (Rs. {tax/2})</div>
                      </Popup.Content>
                    </Popup>
                  ) :
                  (
                    <Popup
                      trigger={<Header as='h4'>{'Rs. '+tax}</Header>}
                      content={'IGST: '+this.props.allItems.tax+'% (Rs. '+tax+')'}
                      size='mini'
                    />
                  )
                }
              </center>
            </td>
            <td><center>{taxable}</center></td>
            <td>
              <center>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={5}>
                  <DeleteIcon onClick={this.props.remove(this.props.id)} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Mrp viewDisplay='none' partno={this.props.allItems.partno}
                       partcodeOption={this.props.partcodeOption}
                       aliasId={this.props.allItems.aliasId} brand_id={this.props.allItems.brand} />
                </Grid.Column>
              </Grid>
              </center>
            </td>
        </tr>
      </tbody>
    );
  }
}

export default Item;
